import React, { FC, PropsWithChildren } from 'react';
import { ConfigProvider } from '@kl/components-v6/design-system/context';
import { GlobalStyle } from '@kl/components-v6/design-system/global-style';
import '@kl/components-v6/design-system/global-style/styles.css';

export const UifConfigProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <ConfigProvider locale={'en-us'}>
            <GlobalStyle />
            {children}
        </ConfigProvider>
    );
};
